import { render, staticRenderFns } from "./FileReader.vue?vue&type=template&id=67907b7e"
import script from "./FileReader.vue?vue&type=script&lang=ts"
export * from "./FileReader.vue?vue&type=script&lang=ts"
import style0 from "./FileReader.vue?vue&type=style&index=0&id=67907b7e&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67907b7e')) {
      api.createRecord('67907b7e', component.options)
    } else {
      api.reload('67907b7e', component.options)
    }
    module.hot.accept("./FileReader.vue?vue&type=template&id=67907b7e", function () {
      api.rerender('67907b7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/upload_tabs/FileReader.vue"
export default component.exports